import { useEffect, useState } from 'react';

// Owns which tab is selected, defaulting/snapping back to the tab that
// matches system-prompt vs. persona mode whenever that mode changes.
export const useConfigurationActiveTab = (systemPromptActive: boolean) => {
  const [activeTabId, setActiveTabId] = useState(systemPromptActive ? 'system-prompt' : 'persona');

  useEffect(() => {
    setActiveTabId(systemPromptActive ? 'system-prompt' : 'persona');
  }, [systemPromptActive]);

  return [activeTabId, setActiveTabId] as const;
};
